
import React from 'react';
import { Check } from 'lucide-react';
import { ArrowRight } from './Icons';

const SolutionFeatures = () => {
  return (
    <div className="flex flex-col justify-center reveal opacity-0 transition-all duration-700 translate-y-8" style={{ transitionDelay: '300ms' }}>
      <h3 className="heading-md mb-6">Transform Data into Decision-Ready Insights</h3>
      <p className="text-gray-600 mb-8">
        Portco AI automatically extracts critical financial metrics from complex documents, normalizes data across your portfolio, and presents it in intuitive dashboards—all with minimal manual input.
      </p>
      
      <div className="space-y-4">
        <div className="flex items-start space-x-4">
          <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <Check className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <div className="font-semibold mb-1">AI-powered data extraction</div>
            <p className="text-gray-600 text-sm">Automatically parse quarterly reports, statements, and updates</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-4">
          <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <Check className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <div className="font-semibold mb-1">Live fund performance tracking</div>
            <p className="text-gray-600 text-sm">Monitor NAV, MOIC, IRR, and EBITDA trends in real-time</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-4">
          <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <Check className="w-4 h-4 text-green-600" />
          </div>
          <div>
            <div className="font-semibold mb-1">Attribution analysis</div>
            <p className="text-gray-600 text-sm">Understand which portfolio companies drive your returns</p>
          </div>
        </div>
      </div>
      
      <div className="mt-10">
        <a
          href="#demo"
          className="btn-primary rounded-full inline-flex items-center"
        >
          <span>See the platform in action</span>
          <ArrowRight className="ml-2 w-4 h-4" />
        </a>
      </div>
    </div>
  );
};

export default SolutionFeatures;
